import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="call-to-action" ref={ref} className="bg-background py-24 flex flex-col items-center justify-center text-center px-6">
      <div className={cn("max-w-4xl mx-auto transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="font-serif font-bold text-4xl md:text-5xl text-primary mb-6 leading-tight">
          Ready to{" "}
          <span className="border-b border-ring pb-1">Transform</span> Your
          Business?
        </h2>
        
        <p className="font-sans text-lg text-muted-foreground mb-10 max-w-2xl mx-auto">
          Discover the innovative solutions that drive growth and efficiency.
          Join us today and let's build something extraordinary together.
        </p>

        <div className="flex justify-center">
          <Link to="#" className="block">
            <Button variant="outline" className="w-[280px] h-12 text-base border-ring text-ring hover:bg-ring hover:text-white hover:border-ring transition-all duration-300 rounded-md bg-transparent shadow-none">
              Get Started
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}